import React, { useMemo } from 'react';

import { IAvailableCandidate } from '@types';
import { availableCandidateSkills, formatSkillLabel } from '@utils';
import { SuggestionSearch } from 'components/candidate/CandidatesList/components/SuggestionSearch';

const SUGGESTION_KINDS = ['Candidates', 'Tech stack'];

interface IAvailableCandidatesSearchProps {
  candidates: IAvailableCandidate[];
  value: string;
  fullWidth?: boolean;
  onChange: (value: string) => void;
}

export const AvailableCandidatesSearch: React.FC<
  IAvailableCandidatesSearchProps
> = ({ candidates, value, fullWidth, onChange }) => {
  const sources = useMemo(
    () =>
      candidates.flatMap((candidate) => [
        { kind: 'Candidates', value: candidate.name },
        ...availableCandidateSkills(candidate).map((skill) => ({
          kind: 'Tech stack',
          value: formatSkillLabel(skill),
        })),
      ]),
    [candidates],
  );

  return (
    <SuggestionSearch
      sources={sources}
      kinds={SUGGESTION_KINDS}
      placeholder="Search by name or stack"
      value={value}
      fullWidth={fullWidth}
      onChange={onChange}
    />
  );
};
